import { Button, Card, Group, Stack, Text } from '@mantine/core'

export const CardInformacoesGrupoRequerimento = ({
    grupoRequerimento,
    handleExportPDF
}) => {
    return (
        <Card
            shadow="xs"
            padding={'lg'}
            radius="sm"
            style={{
                backgroundColor: '#DDE9ED'
            }}
        >
            <Stack gap={'1.5rem'}>
                <Group justify="space-between" align="flex-start">
                    <Stack gap={'0.5rem'}>
                        <Text size="1.5rem" c={'#295661'} fw={'bold'}>
                            Requisitos para o/a {' '}
                            {grupoRequerimento?.nomeExibicao}
                        </Text>
                        <Text size="1.15rem" c={'#295661'} mt={'1.5rem'}>
                            Fase(s):{' '}
                            <Text size="1.15rem" c={'#295661'} span fw={'bold'}>
                                {grupoRequerimento?.fasesString}
                            </Text>
                        </Text>
                    </Stack>
                    <Button variant="subtle" onClick={handleExportPDF}>
                        Exportar PDF
                    </Button>
                </Group>
            </Stack>
        </Card>
    )
}
